import React, { useState, useEffect } from "react";
import styled from "styled-components";
import useResponsiveImageUrl from "src/utils/useResponsiveImageUrl";
import Spinner from "src/components/Spinner";

const WinAMillionTV = () => {
  const [totalAmount, setTotalAmount] = useState(null);
  const [error, setError] = useState(false);
  const backgroundImage = useResponsiveImageUrl(
    "promotions/gaming-machines/win-a-million-2025/Win-A-Million-TV-Background-Image.jpg"
  );

  useEffect(() => {
    const fetchTotalAmount = async () => {
      try {
        // Add timestamp to prevent caching
        const timestamp = new Date().getTime();
        const response = await fetch(
          `https://script.google.com/macros/s/AKfycbzmCfGkeW7Mh5sHZuqiclAnTYhldaCcDs2uxEyy-i_LCXFnEjAjRe86XdQMysi2W1dK/exec?t=${timestamp}`
        );
        
        const data = await response.json();
        
        if (data && data.total) {
          setTotalAmount(data.total);
        } else {
          setError(true);
          setTotalAmount("Error loading data");
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(true);
        setTotalAmount("Error loading data");
      }
    };

    // Initial fetch
    fetchTotalAmount();

    // Refresh every 5 seconds for real-time live game updates
    const interval = setInterval(fetchTotalAmount, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <TVContainer>
      <BackgroundImage src={backgroundImage} alt="Win A Million Background" />
      <AmountDisplay error={error}>
        {totalAmount ? (
          totalAmount
        ) : (
          <GoldSpinner>
            <Spinner variant="dark" />
          </GoldSpinner>
        )}
      </AmountDisplay>
    </TVContainer>
  );
};

const TVContainer = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background-color: #000;
  margin: 0;
  padding: 0;
`;

const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const AmountDisplay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 30rem;
  font-weight: bold;
  color: ${(props) => (props.error ? "#ff0000" : "var(--white)")};
  text-shadow:
    0 0 20px rgba(0, 0, 0, 0.8),
    0 0 40px rgba(0, 0, 0, 0.6),
    0 0 60px rgba(0, 0, 0, 0.4);
  font-family: Arial, sans-serif;
  letter-spacing: 0.05em;
  z-index: 10;
`;

const GoldSpinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: var(--white) !important;
    font-size: 10rem;
    margin-bottom: 50%;
  }
`;

export default WinAMillionTV;
